import type { ReactElement } from "react";
// eslint-disable-next-line no-restricted-imports -- DS shell: sole `react-toastify` import in @/ui
import { ToastContainer, type ToastContainerProps } from "react-toastify";

export type ToastProps = ToastContainerProps;

/**
 * DS wrapper around react-toastify `ToastContainer` (Snackbar V2 tokens).
 * App shell should render one instance; use `toast()` from `react-toastify` in hooks only.
 */
export function Toast(props: ToastProps): ReactElement {
    return <ToastContainer {...props} />;
}
